import React from "react";

export const InsufficientPrivileges = () => (
  <div className="margin-left-half padding-top">
    Your user does not have access to this method.
  </div>
);
